import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
    {
        id: "po-07-h2v5-01",
        name: "PO 01 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 48, y: 229, width: 289, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 418, width: 289, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 229, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "4", x: 751, y: 102, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 751, y: 418, width: 219, height: 307, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 102, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 418, width: 219, height: 307, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-02",
        name: "PO 02 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 48, y: 229, width: 289, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 418, width: 289, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 229, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "4", x: 703, y: 155, width: 407, height: 518, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 154, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 330, width: 122, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1118, y: 505, width: 122, height: 167, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-03",
        name: "PO 03 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 69, y: 155, width: 537, height: 271, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 434, width: 365, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 434, width: 165, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 703, y: 155, width: 407, height: 518, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 154, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 330, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1118, y: 505, width: 122, height: 167, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-04",
        name: "PO 04 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 69, y: 155, width: 412, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 69, y: 418, width: 412, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 489, y: 155, width: 118, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 489, y: 331, width: 118, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 489, y: 506, width: 118, height: 167, rotation: 0, imageRotation: 0 },
            { id: "6", x: 705, y: 219, width: 265, height: 391, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 219, width: 264, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-05",
        name: "PO 05 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 217, width: 275, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 703, y: 155, width: 407, height: 518, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 217, width: 254, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 340, y: 419, width: 254, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 155, width: 122, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 331, width: 122, height: 167, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1118, y: 506, width: 122, height: 167, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-06",
        name: "PO 06 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 93, y: 162, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 418, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "3", x: 269, y: 162, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "4", x: 269, y: 418, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 445, y: 162, width: 355, height: 504, rotation: 0, imageRotation: 0 },
            { id: "6", x: 808, y: 162, width: 397, height: 248, rotation: 0, imageRotation: 0 },
            { id: "7", x: 808, y: 418, width: 397, height: 248, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-07",
        name: "PO 07 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 93, y: 162, width: 168, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 269, y: 162, width: 167, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 444, y: 162, width: 397, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 93, y: 418, width: 397, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 498, y: 418, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "6", x: 674, y: 418, width: 167, height: 248, rotation: 0, imageRotation: 0 },
            { id: "7", x: 849, y: 162, width: 356, height: 505, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-08",
        name: "PO 08 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 267, width: 199, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 207, y: 267, width: 198, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 413, y: 267, width: 472, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 893, y: 267, width: 199, height: 293, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1100, y: 267, width: 198, height: 143, rotation: 0, imageRotation: 0 },           
            { id: "6", x: 1100, y: 417, width: 95, height: 143, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1203, y: 417, width: 95, height: 143, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-09",
        name: "PO 09 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 93, y: 162, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 418, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "3", x: 269, y: 162, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "4", x: 269, y: 418, width: 168, height: 248, rotation: 0, imageRotation: 0 },
            { id: "5", x: 848, y: 162, width: 357, height: 504, rotation: 0, imageRotation: 0 },
            { id: "6", x: 445, y: 162, width: 395, height: 248, rotation: 0, imageRotation: 0 },
            { id: "7", x: 445, y: 418, width: 395, height: 248, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-10",
        name: "PO 10 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 81, y: 0, width: 643, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 81, y: 418, width: 643, height: 409, rotation: 0, imageRotation: 0 },
            { id: "3", x: 732, y: 0, width: 197, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 279, width: 197, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 732, y: 557, width: 197, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 937, y: 0, width: 280, height: 410, rotation: 0, imageRotation: 0 },
            { id: "7", x: 937, y: 418, width: 280, height: 410, rotation: 0, imageRotation: 0 }
        ],
    }
];